<template>
  <span class="ws-exam-approve">
    <ws-role-node :only="['front_rcc', 'front_admin', 'front_mio', 'front_50plus', 'front_curator']">
      <popper
        trigger="hover"
        :options="{placement: 'top'}"
        v-if="exam.status === examStatus.AGREED_DE_DEPARTMENT"
      >
        <div class="popper is-warning has-text-left exam-status-hint">
          <b>Для подтверждения необходимо:</b>
          <ul>

            <template v-if="!isRemoteExperts">
              <li
                v-if="isHasMainExpert"
                class="has-text-success"
              >
                <ws-icon
                  name="check-mark"
                  color="#3f842f"
                  width="16"
                  height="16"
                />
                <span>{{$t('Запросить главного эксперта')}}</span>
              </li>
              <li
                v-else
                class="has-text-danger"
              >
                <ws-icon
                  name="close"
                  color="#EB5757"
                  width="16"
                  height="16"
                />
                <span>{{$t('Запросить главного эксперта')}}</span>
              </li>
            </template>

            <template v-if="!isRemoteExperts && !isDepartment">
              <li
                v-if="isHasExperts"
                class="has-text-success"
              >
                <ws-icon
                  name="check-mark"
                  color="#3f842f"
                  width="16"
                  height="16"
                />
                <span>{{$t('Добавить экспертов')}}</span>
              </li>
              <li
                v-else
                class="has-text-danger"
              >
                <ws-icon
                  name="close"
                  color="#EB5757"
                  width="16"
                  height="16"
                />
                <span>{{$t('Добавить экспертов')}}</span>
              </li>
            </template>

            <!--            <template v-if="!isRemoteExperts">-->
            <!--              <li v-if="isExpertsAccepted" class="has-text-success">-->
            <!--                <ws-icon name="check-mark" color="#3f842f" width="16" height="16"/>-->
            <!--                <span>{{$t('Назначить экспертов')}}</span>-->
            <!--              </li>-->
            <!--              <li v-else class="has-text-danger">-->
            <!--                <ws-icon name="close" color="#EB5757" width="16" height="16"/>-->
            <!--                <span>{{$t('Назначить экспертов')}}</span>-->
            <!--              </li>-->
            <!--            </template>-->

            <li
              v-if="isHasTechnicalExperts"
              class="has-text-success"
            >
              <ws-icon
                name="check-mark"
                color="#3f842f"
                width="16"
                height="16"
              />
              <span>{{$t('Добавить технических экспертов')}}</span>
            </li>
            <li
              v-else
              class="has-text-danger"
            >
              <ws-icon
                name="close"
                color="#EB5757"
                width="16"
                height="16"
              />
              <span>{{$t('Добавить технических экспертов')}}</span>
            </li>

            <li
              v-if="getCountOfAllParticipants > 0"
              class="has-text-success"
            >
              <ws-icon
                name="check-mark"
                color="#3f842f"
                width="16"
                height="16"
              />
              <span>{{$t('Добавить участников в группы')}}</span>
            </li>
            <li
              v-else
              class="has-text-danger"
            >
              <ws-icon
                name="close"
                color="#EB5757"
                width="16"
                height="16"
              />
              <span>{{$t('Добавить участников в группы')}}</span>
            </li>

            <template v-if="currentRole === 'front_rcc'">
              <li
                v-if="isParticipantsRequiredFieldsCompleted"
                class="has-text-success"
              >
                <ws-icon
                  name="check-mark"
                  color="#3f842f"
                  width="16"
                  height="16"
                />
                <span>{{$t('Заполнены обязательные поля в профиле участников (ФИО, ГИА 9/11, СНИЛС)')}}</span>
              </li>
              <li
                v-else
                class="has-text-danger"
              >
                <ws-icon
                  name="close"
                  color="#EB5757"
                  width="16"
                  height="16"
                />
                <span v-if="isParticipantsHasRequiredFields">{{$t('Заполнены обязательные поля в профиле участников (ФИО, ГИА 9/11, СНИЛС)')}}</span>
                <span v-else>{{$t('Проверьте данные в карточке ДЭ')}}</span>
              </li>
            </template>
               <li
                 v-if="isAcredentialled"
                 class="has-text-success"
               >
              <ws-icon
                name="check-mark"
                color="#3f842f"
                width="16"
                height="16"
              />
              <span>{{$t('Наличие обследования у ЦПДЭ')}}</span>
            </li>

             <li
               v-else
               class="has-text-danger"
             >
              <ws-icon
                name="close"
                color="#EB5757"
                width="16"
                height="16"
              />
              <span>{{$t('Наличие обследования у ЦПДЭ')}}</span>
            </li>
          </ul>
        </div>
        <div
          class="ws-button-wrapper"
          slot="reference"
        >
          <button
            class="ws-button button is-text"
            :disabled="!isCanApproveForAdminFifty || isStatusUpdating || (currentRole === 'front_rcc' && !isParticipantsRequiredFieldsCompleted) || isBlockedStatus || !isAcredentialled"
            @click="updateExamStatus(examStatus.CONFIRMED_AUTH_ORG)"
          >
            <ws-icon
              class="ws-button__icon"
              name="check-mark"
              :title="currentRole === 'front_50plus' || currentRole === 'front_mio' ? $t('Согласовать проведение') : $t('Подтвердить проведение экзамена (Куратор ОО)')"
              color="#1c3b8d"
              width="20"
              height="20"
            />
            <span
              class="ws-button__text has-text-primary"
              v-text="currentRole === 'front_50plus' || currentRole === 'front_mio' ? $t('Согласовать проведение') : $t('Подтвердить проведение экзамена (Куратор ОО)')"
            ></span>
            <ws-spinner v-if="isStatusUpdating"></ws-spinner>
          </button>
        </div>
      </popper>
    </ws-role-node>
    <ws-role-node :only="['front_dep', 'front_education_ministry', 'front_admin']">
      <button
        class="ws-button button is-text"
        v-if="exam.status === examStatus.CONFIRMED_AUTH_ORG || exam.status === examStatus.CONFIRMED_AUTH_ORG_BLOCKED"
        :disabled="isStatusUpdating || isStatusReverting || isBlockedStatus"
        @click="updateExamStatus(examStatus.AGREED_DE_DEPARTMENT)"
      >
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          :title="$t('Отменить подтверждение')"
          color="#EB5757"
          width="16"
          height="16"
        />
        <span
          class="ws-button__text has-text-danger"
          v-text="$t('Отменить подтверждение экзамена (РО)')"
        ></span>
        <ws-spinner v-if="isStatusReverting"></ws-spinner>
      </button>
    </ws-role-node>
    <ws-role-node :only="['front_rcc']">
      <button
        class="ws-button button is-text"
        disabled
        v-if="(exam.status === examStatus.CONFIRMED_AUTH_ORG || exam.status === examStatus.CONFIRMED_AUTH_ORG_BLOCKED) && isShowStatus"
      >
        <ws-icon
          class="ws-button__icon"
          name="check-mark"
          :title="$t('Проведение экзамена подтверждено (РО)')"
          color="#3f842f"
          width="20"
          height="20"
        />
        <span
          class="ws-button__text has-text-success"
          v-text="$t('Проведение экзамена подтверждено (РО)')"
        ></span>
      </button>
    </ws-role-node>
    <ws-role-node :only="['front_dep', 'front_admin']">
      <button
        class="ws-button button is-text"
        :disabled="isStatusUpdating"
        @click="onBlockStatus"
        v-if="exam.status !== examStatus.AGREED_DE_DEPARTMENT && !isBlockedStatus"
      >
        <ws-icon
          class="ws-button__icon"
          name="check-mark"
          :title="$t('Заблокировать')"
          color="#EB5757"
          width="20"
          height="20"
        />
        <span
          class="ws-button__text has-text-danger"
          v-text="$t('Заблокировать')"
        ></span>
        <ws-spinner v-if="isStatusUpdating"></ws-spinner>
      </button>
    </ws-role-node>
    <ws-role-node :only="['front_dep', 'front_admin']">
      <button
        class="ws-button button is-text"
        :disabled="isStatusUpdating"
        @click="onBlockStatus"
        v-if="isBlockedStatus"
      >
        <ws-icon
          class="ws-button__icon"
          name="check-mark"
          :title="$t('Разблокировать')"
          color="#1c3b8d"
          width="20"
          height="20"
        />
        <span
          class="ws-button__text has-text-primary"
          v-text="$t('Разблокировать')"
        ></span>
        <ws-spinner v-if="isStatusUpdating"></ws-spinner>
      </button>
    </ws-role-node>
    <ws-role-node :only="['front_me', 'front_dep', 'front_education_ministry', 'front_admin']">
      <popper
        trigger="hover"
        :options="{ placement: 'top' }"
        v-if="exam.status === 'confirmed_auth_org' || exam.status === 'confirmed_auth_org_blocked'"
      >
        <div class="popper is-warning has-text-left exam-status-hint">
          <b>Подтвердить готовность к проведению ДЭ</b>
          <ul>
            <li
              v-if="isMainExpertAccepted"
              class="has-text-success"
            >
              <ws-icon
                name="check-mark"
                color="#3f842f"
                width="16"
                height="16"
              />
              <span>{{$t('Главный эксперт утвержден')}}</span>
            </li>
            <li
              v-else
              class="has-text-danger"
            >
              <ws-icon
                name="close"
                color="#EB5757"
                width="16"
                height="16"
              />
              <span>{{$t('Главный эксперт утвержден')}}</span>
            </li>

            <li
              v-if="isExpertsAccepted"
              class="has-text-success"
            >
              <ws-icon
                name="check-mark"
                color="#3f842f"
                width="16"
                height="16"
              />
              <span>{{$t('Эксперты назначены')}}</span>
            </li>
            <li
              v-else
              class="has-text-danger"
            >
              <ws-icon
                name="close"
                color="#EB5757"
                width="16"
                height="16"
              />
              <span>{{$t('Эксперты назначены')}}</span>
            </li>

            <li
              v-if="isTechnicalExpertsAccepted"
              class="has-text-success"
            >
              <ws-icon
                name="check-mark"
                color="#3f842f"
                width="16"
                height="16"
              />
              <span>{{$t('Технические эксперты назначены')}}</span>
            </li>
            <li
              v-else
              class="has-text-danger"
            >
              <ws-icon
                name="close"
                color="#EB5757"
                width="16"
                height="16"
              />
              <span>{{$t('Технические эксперты назначены')}}</span>
            </li>

            <li
              v-if="isParticipantsApprovedInAllShifts"
              class="has-text-success"
            >
              <ws-icon
                name="check-mark"
                color="#3f842f"
                width="16"
                height="16"
              />
              <span>{{$t('Присутствие участников подтверждено')}}</span>
            </li>
            <li
              v-else
              class="has-text-danger"
            >
              <ws-icon
                name="close"
                color="#EB5757"
                width="16"
                height="16"
              />
              <span>{{$t('Присутствие участников подтверждено')}}</span>
            </li>
          </ul>
        </div>
        <div
          class="ws-button-wrapper"
          slot="reference"
        >
          <button
            class="ws-button button is-text"
            :disabled="!isCanApprove || isStatusUpdating || isBlockedStatus"
            @click="updateExamStatus(examStatus.APPROVED_MAIN_EXPERT)"
          >
            <ws-icon
              class="ws-button__icon"
              name="check-mark"
              :title="$t('Подтвердить проведение экзамена ГЭ')"
              color="#1c3b8d"
              width="20"
              height="20"
            />
            <span
              class="ws-button__text has-text-primary"
              v-text="$t('Подтвердить проведение экзамена ГЭ')"
            ></span>
            <ws-spinner v-if="isStatusUpdating"></ws-spinner>
          </button>
        </div>
      </popper>
    </ws-role-node>
    <button
      class="ws-button button is-text"
      disabled
      v-if="(exam.status === examStatus.APPROVED_MAIN_EXPERT || exam.status === examStatus.APPROVED_MAIN_EXPERT_BLOCKED) && isShowStatus"
    >
      <strong
        class="ws-button__text has-text-danger"
        v-text="$t('ДЭ не завершен')"
      ></strong>
    </button>
<!--    <ws-role-node-->
<!--      v-if="isShowComplete"-->
<!--      :only="['front_me', 'front_mc', 'front_dep', 'front_education_ministry', 'front_admin', 'front_rcc']"-->
<!--    >-->
<!--      <popper-->
<!--        trigger="hover"-->
<!--        :options="{ placement: 'top' }"-->
<!--        v-if="exam.status === examStatus.APPROVED_MAIN_EXPERT || exam.status === examStatus.APPROVED_MAIN_EXPERT_BLOCKED"-->
<!--      >-->
<!--        <div class="popper is-warning has-text-left exam-status-hint">-->
<!--          <b>Для завершения экзамена необходимо:</b>-->
<!--          <ul>-->
<!--            <template v-if="!isExam50Plus">-->
<!--              <li-->
<!--                v-if="isMainExpertDocUploaded"-->
<!--                class="has-text-success"-->
<!--              >-->
<!--                <ws-icon-->
<!--                  name="check-mark"-->
<!--                  color="#3f842f"-->
<!--                  width="16"-->
<!--                  height="16"-->
<!--                />-->
<!--                <span>{{$t('Отчет главного эксперта загружен')}}</span>-->
<!--              </li>-->
<!--              <li-->
<!--                v-else-->
<!--                class="has-text-danger"-->
<!--              >-->
<!--                <ws-icon-->
<!--                  name="close"-->
<!--                  color="#EB5757"-->
<!--                  width="16"-->
<!--                  height="16"-->
<!--                />-->
<!--                <span>{{$t('Отчет главного эксперта загружен')}}</span>-->
<!--              </li>-->
<!--              <li-->
<!--                v-if="isReportUploaded"-->
<!--                class="has-text-success"-->
<!--              >-->
<!--                <ws-icon-->
<!--                  name="check-mark"-->
<!--                  color="#3f842f"-->
<!--                  width="16"-->
<!--                  height="16"-->
<!--                />-->
<!--                <span>{{$t('Акт готовности площадки загружен')}}</span>-->
<!--              </li>-->
<!--              <li-->
<!--                v-else-->
<!--                class="has-text-danger"-->
<!--              >-->
<!--                <ws-icon-->
<!--                  name="close"-->
<!--                  color="#EB5757"-->
<!--                  width="16"-->
<!--                  height="16"-->
<!--                />-->
<!--                <span>{{$t('Акт готовности площадки загружен')}}</span>-->
<!--              </li>-->
<!--            </template>-->
<!--            <li-->
<!--              v-if="isParticipantsHasResults"-->
<!--              class="has-text-success"-->
<!--            >-->
<!--              <ws-icon-->
<!--                name="check-mark"-->
<!--                color="#3f842f"-->
<!--                width="16"-->
<!--                height="16"-->
<!--              />-->
<!--              <span>{{$t('Наличие результатов у участников')}}</span>-->
<!--            </li>-->
<!--            <li-->
<!--              v-else-->
<!--              class="has-text-danger"-->
<!--            >-->
<!--              <ws-icon-->
<!--                name="close"-->
<!--                color="#EB5757"-->
<!--                width="16"-->
<!--                height="16"-->
<!--              />-->
<!--              <span>{{$t('Наличие результатов у участников')}}</span>-->
<!--            </li>-->

<!--            <template v-if="isExamNoc">-->
<!--              <li-->
<!--                v-if="isAtLeastOneParticipantNoc"-->
<!--                class="has-text-success"-->
<!--              >-->
<!--                <ws-icon-->
<!--                  name="check-mark"-->
<!--                  color="#3f842f"-->
<!--                  width="16"-->
<!--                  height="16"-->
<!--                />-->
<!--                <span>{{$t('Наличие файлов НОК у участников')}}</span>-->
<!--              </li>-->
<!--              <li-->
<!--                v-else-->
<!--                class="has-text-danger"-->
<!--              >-->
<!--                <ws-icon-->
<!--                  name="close"-->
<!--                  color="#EB5757"-->
<!--                  width="16"-->
<!--                  height="16"-->
<!--                />-->
<!--                <span>{{$t('Наличие файлов НОК у участников')}}</span>-->
<!--              </li>-->
<!--            </template>-->
<!--          </ul>-->
<!--        </div>-->
<!--        <div-->
<!--          class="ws-button-wrapper"-->
<!--          slot="reference"-->
<!--        >-->
<!--          <button-->
<!--            class="ws-button button is-text"-->
<!--            :disabled="!isCanComplete || isStatusUpdating || isBlockedStatus"-->
<!--            @click="updateExamStatus(examStatus.COMPLETE_MAIN_EXPERT)"-->
<!--          >-->
<!--            <ws-icon-->
<!--              class="ws-button__icon"-->
<!--              name="check-mark"-->
<!--              :title="$t('Завершить экзамен')"-->
<!--              color="#1c3b8d"-->
<!--              width="20"-->
<!--              height="20"-->
<!--            />-->
<!--            <span-->
<!--              class="ws-button__text has-text-primary"-->
<!--              v-text="$t('Завершить экзамен')"-->
<!--            ></span>-->
<!--            <ws-spinner v-if="isStatusUpdating"></ws-spinner>-->
<!--          </button>-->
<!--        </div>-->
<!--      </popper>-->
<!--    </ws-role-node>-->
    <button
      class="ws-button button is-text"
      disabled
      v-show="(exam.status === examStatus.COMPLETE_MAIN_EXPERT || exam.status === examStatus.COMPLETE_MAIN_EXPERT_BLOCKED) && isShowComplete && isShowStatus"
    >
      <ws-icon
        class="ws-button__icon"
        name="check-mark"
        :title="$t('Экзамен завершен')"
        color="#3f842f"
        width="20"
        height="20"
      />
      <strong class="ws-button__text has-text-success">
        {{$t('ДЭ завершен')}}
        <ws-time-formatter :date="exam.updated_at" format="LL"></ws-time-formatter>
      </strong>
    </button>
  </span>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Popper from 'vue-popperjs'
import { isDeCenterAccredited } from '@/utils/isDeCenterAccreditated'
import getCountOfParticipants from '@/utils/getCountOfParticipants'
import { constants } from '@/services/constants.service'
import expertStatus from './data/expertStatusEnum'
import isBlockedExam from '@/mixins/is-blocked-exam.mixin'
import { get } from 'lodash'

export default {
  name: 'WsDemoExamsApprove',
  components: { 'popper': Popper },
  props: {
    accred_comps: {
      type: Object,
      default: null
    },
    exam: Object,
    files: Object,
    isShowComplete: {
      type: Boolean,
      default: false
    },
    isShowStatus: {
      type: Boolean,
      default: false
    }
  },
  mixins: [isBlockedExam],
  data () {
    return {
      isStatusUpdating: false,
      isStatusReverting: false,
      expertStatus,
      examStatus: constants.exam_status
    }
  },
  computed: {
    ...mapState('exams', {
      isFindPending: 'isFindPending'
    }),
    ...mapState('authentication', ['currentRole']),
    isAcredentialled () {
      const flags = this.exam ? this.exam.flags : undefined
      const accredComps = this.accred_comps ? this.accred_comps : this.exam.accred_comps
      return accredComps ? isDeCenterAccredited(accredComps, flags) : false
    },
    isExamNoc () {
      return this.exam.flags.indexOf(constants.exam_flags.INDEPENDENT_ESTIMATE) > -1
    },
    examParticipants () {
      const groups = this.exam.shifts ? [...this.exam.shifts.map(item => item.groups || [])].flat() : []
      return groups.map(group => group.participants || []).flat()
    },
    isDepartment () {
      return this.currentRole === 'front_dep'
    },
    isAtLeastOneParticipantNoc () {
      return this.examParticipants.some(participant => participant.files['de-participants-noc'].guid !== constants.NULL_GUID)
    },
    isRemoteExperts () {
      return this.exam.flags.indexOf(constants.exam_flags.REMOTE_EXPERTS) > -1
    },
    isRemoteParticipants () {
      return this.exam.flags.indexOf(constants.exam_flags.REMOTE_MEMBERS) > -1
    },
    isExam50Plus () {
      return this.exam.flags.indexOf('50_plus') > -1 || this.exam.flags.indexOf('master_of_industrial_edu') > -1
    },
    isExpertsAccepted () {
      return this.exam.experts && this.exam.experts.find(e => e.expert_exam_status === expertStatus.accepted)
    },
    isTechnicalExpertsAccepted () {
      return this.exam.technical_experts && this.exam.technical_experts.find(e => e.expert_exam_status === expertStatus.accepted)
    },
    isParticipantsApprovedInAllShifts () {
      if (!this.exam.shifts) {
        return false
      }

      const groups = this.exam.shifts.map(el => el.groups).flat()
      const participants = groups.map(g => g.participants).flat().filter(p => p)
      return participants.every(p => p.status === 'approved' || p.status === 'passed')
    },
    isParticipantsHasRequiredFields () {
      return this.exam.shifts && !this.exam.shifts.find(s => {
        if (s.groups) {
          return s.groups.find(g => {
            if (g.participants) {
              return !g.participants.find(p => {
                return p.user_info.profile_stat && p.user_info.profile_stat.required_fields
              })
            } else {
              return false
            }
          })
        } else {
          return true
        }
      })
    },
    isParticipantsRequiredFieldsCompleted () {
      return this.exam.shifts && !this.exam.shifts.find(s => {
        if (s.groups) {
          return s.groups.find(g => {
            if (g.participants) {
              return !g.participants.find(p => {
                return p.user_info.profile_stat &&
                  p.user_info.profile_stat.required_fields && (p.user_info.profile_stat.required_fields['documents/insurance-number'] &&
                    p.user_info.profile_stat.required_fields['general/base_education_level'] &&
                    p.user_info.profile_stat.required_fields['first'] &&
                    p.user_info.profile_stat.required_fields['last'])
              })
            } else {
              return false
            }
          })
        } else {
          return true
        }
      })
    },
    isMainExpertAccepted () {
      return this.exam.main_expert.expert_exam_status === expertStatus.accepted
    },
    isCanApprove () {
      if (this.isRemoteExperts) {
        /* eslint-disable no-mixed-operators */
        return this.isExpertsAccepted &&
          this.isParticipantsApprovedInAllShifts && (
          this.isMainExpertAccepted && this.isRemoteParticipants ||
            this.isMainExpertAccepted && this.isTechnicalExpertsAccepted
        )
      } else {
        return this.isExpertsAccepted &&
          this.isParticipantsApprovedInAllShifts &&
          this.isMainExpertAccepted && this.isTechnicalExpertsAccepted
      }
    },
    isHasExperts () {
      return this.exam.experts && this.exam.experts.length
    },
    isHasTechnicalExperts () {
      return this.exam.technical_experts && this.exam.technical_experts.length > 0
    },
    isDeCenterAccredited () {
      return isDeCenterAccredited(this.exam.accred_comps, this.exam.flags)
    },
    getCountOfParticipants () {
      return getCountOfParticipants(this.exam)
    },
    getCountOfAllParticipants () {
      const groups = this.exam.shifts ? [...this.exam.shifts.map(item => item.groups || [])].flat() : []
      const count = groups ? groups.map(group => group.participants).flat().filter(item => !!item).length : 0
      return count === 0 ? '0' : count
    },
    isHasMainExpert () {
      return this.exam.main_expert.guid !== constants.NULL_GUID
    },
    isTechnicalExpertValidated () {
      if (this.isRemoteParticipants) {
        return true
      } else {
        return this.isHasTechnicalExperts
      }
    },
    isCanApproveForAdminFifty () {
      if (this.isRemoteExperts) {
        return (this.getCountOfAllParticipants > 0 && this.isHasTechnicalExperts) ||
        ['front_50plus', 'front_mio'].indexOf(this.currentRole) > -1
      } else {
        return (this.isHasMainExpert &&
          this.getCountOfAllParticipants > 0 &&
          this.isHasTechnicalExperts &&
          (this.isHasExperts || this.isDepartment)) ||
          ['front_50plus', 'front_mio'].indexOf(this.currentRole) > -1
      }
    },
    isMainExpertDocUploaded () {
      // Костыль. почему-то получилось два названия у документов. Лучше искать сразу по двум названиям
      const files = get(this.files, 'de-docs', get(this.files, 'docs', []))
      if (files) {
        return files.length
      }
      return []
    },
    isReportUploaded () {
      // Костыль. почему-то получилось два названия у документов. Лучше искать сразу по двум названиям
      const files = get(this.files, 'de-reports', get(this.files, 'de-reports', []))
      return files.length
    },
    isParticipantsHasResults () {
      return this.exam.shifts && !this.exam.shifts.some(shift => {
        if (shift.groups) {
          return shift.groups.find(group => {
            if (group.participants) {
              return !group.participants.some(participant => {
                const scaledMarkCheck = !participant.scaled_mark || (participant.scaled_mark && participant.scaled_mark.imported_at !== '0001-01-01T00:00:00Z')

                return this.exam.evaluation_in_new_cis ? !!participant.passport_url : scaledMarkCheck
              })
            } else {
              return true
            }
          })
        } else {
          return true
        }
      })
    },
    isCanComplete () {
      return (this.isExam50Plus || this.isMainExpertDocUploaded) &&
        (this.isExam50Plus || this.isReportUploaded) &&
        this.isParticipantsHasResults &&
        (this.isExamNoc ? this.isAtLeastOneParticipantNoc : true)
    }
  },
  methods: {
    ...mapActions('exams', ['update']),
    async updateExamStatus (status) {
      let message = 'Проведение экзамена подтверждено'
      let isReverting = false
      const update = async () => {
        if (isReverting) {
          this.isStatusReverting = true
        } else {
          this.isStatusUpdating = true
        }
        try {
          await this.update([this.exam.guid, [], `/status/${status}`])
          this.$buefy.toast.open({
            message: this.$t(message),
            type: 'is-success'
          })
        } catch (e) {
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
            type: 'is-danger'
          })
        }
        if (isReverting) {
          this.isStatusReverting = false
        } else {
          this.isStatusUpdating = false
        }
        this.$emit('update')
      }
      const statuses = Object.entries(this.examStatus).map(s => s[1])
      if (statuses.indexOf(this.exam.status) > statuses.indexOf(status)) {
        message = 'Проведение экзамена отменено'
        isReverting = true
      }
      if (status === constants.exam_status.CONFIRMED_AUTH_ORG && !isReverting && (this.isRemoteExperts && (!this.isHasMainExpert || !this.isHasExperts || !this.isExpertsAccepted))) {
        this.$buefy.dialog.confirm({
          title: this.$t(`В экзамене отсутствуют эксперты. Вы действительно хотите подтвердить экзамен?`),
          cancelText: this.$t('Отмена'),
          confirmText: this.$t('Подтвердить'),
          type: 'is-success',
          onConfirm: async () => {
            await update()
          }
        })
        return
      }
      if (status === constants.exam_status.APPROVED_MAIN_EXPERT) {
        message = 'ДЭ успешно подтвержден и скоро станет доступен в Цифровой системе оценивания'
      }
      if (status === constants.exam_status.COMPLETE_MAIN_EXPERT) {
        message = 'Экзамен завершен'
        this.$buefy.dialog.confirm({
          title: this.$t(`Вы действительно хотите завершить экзамен? После завершени экзамена, будет невозможно изменить ДЭ`),
          cancelText: this.$t('Отмена'),
          confirmText: this.$t('Завершить'),
          type: 'is-success',
          onConfirm: async () => {
            await update()
          }
        })
      } else {
        await update()
      }
    },
    async onBlockStatus () {
      let status = ''
      switch (this.exam.status) {
        case this.examStatus.CONFIRMED_AUTH_ORG:
          status = this.examStatus.CONFIRMED_AUTH_ORG_BLOCKED
          break
        case this.examStatus.APPROVED_MAIN_EXPERT:
          status = this.examStatus.APPROVED_MAIN_EXPERT_BLOCKED
          break
        case this.examStatus.COMPLETE_MAIN_EXPERT:
          status = this.examStatus.COMPLETE_MAIN_EXPERT_BLOCKED
          break
        case this.examStatus.CONFIRMED_AUTH_ORG_BLOCKED:
          status = this.examStatus.CONFIRMED_AUTH_ORG
          break
        case this.examStatus.APPROVED_MAIN_EXPERT_BLOCKED:
          status = this.examStatus.APPROVED_MAIN_EXPERT
          break
        case this.examStatus.COMPLETE_MAIN_EXPERT_BLOCKED:
          status = this.examStatus.COMPLETE_MAIN_EXPERT
          break
      }
      if (this.isBlockedStatus) {
        this.isStatusUpdating = true
        await this.update([this.exam.guid, [], `/status/${status}`])
        this.$buefy.toast.open({
          message: 'Экзамен разблокирован',
          type: 'is-success'
        })
        this.isStatusUpdating = false
      } else {
        this.$buefy.dialog.prompt({
          title: this.$t('Причина блокировки'),
          confirmText: this.$t('Отправить'),
          cancelText: this.$t('Отмена'),
          inputAttrs: {
          },
          scroll: 'clip',
          trapFocus: true,
          onConfirm: async (value) => {
            this.isStatusUpdating = true
            await this.update([this.exam.guid, { blocking_comment: value }, `/status/${status}`])
            this.$buefy.toast.open({
              message: 'Экзамен заблокирован',
              type: 'is-success'
            })
            this.isStatusUpdating = false
          }
        })
      }
    }
  }
}
</script>
